module.exports = __webpack_public_path__ + "src/assets/img/05_medizin.5e8a45a3.svg";